import { computed, defineComponent, inject, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxListOfValues',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Article.
         */
        const article = inject('article');
        const { erid } = article;
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const currentItems = computed(() => {
            const items = (Array.isArray(props.box.data?.items) ? props.box.data?.items : []);
            const isMarker = props.box.isAdvMarker;
            return items.reduce((list, { key, value }) => {
                let tag = 'div';
                const props = {};
                key = `${key.trim()}${key.toLowerCase() === 'реклама' && isMarker ? ',' : ''}`;
                value = value.trim();
                // Ignore erid
                if (erid && (key.includes(erid) || value.includes(erid))) {
                    return list;
                }
                if (value.startsWith('http') || value.startsWith('//')) {
                    tag = 'a';
                }
                if (tag === 'a') {
                    props.href = value;
                    props.rel = 'noopener noreferer nofollow';
                    props.target = '_blank';
                }
                list.push({
                    key,
                    props,
                    tag,
                    value,
                });
                return list;
            }, []);
        });
        const currentID = computed(() => {
            return (props.box.data && props.box.data.id) || '';
        });
        return {
            css,
            currentID,
            currentItems,
        };
    },
});
